import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '@clerk/clerk-react';

// J — local color constants because AppBar sits outside .j-workspace,
// so CSS variables from jTheme.css are not available here.
const J = {
    muted: '#a3d1ff',
    accent: '#66b2ff',
};
const publicNavItems = ['Features', 'Guide', 'FAQ', 'Blog'];

// Experimental/rarely-used pages, grouped under the Proto's dropdown
const protoItems = [
    { label: 'Designer', path: '/designer' },
    { label: 'Bookshelf', path: '/bookshelf' },
    { label: 'CurrentState', path: '/currentstate' },
    { label: 'Klippy', path: '/klippy' },
];

/**
 * Horizontal nav buttons for desktop AppBar.
 * Dashboard only visible when signed in.
 * Proto's is a dropdown grouping experimental/rarely-used pages.
 * Active route highlighted with accent color.
 */
export default function AppBarNavItems() {
    const navigate = useNavigate();
    const location = useLocation();
    const { userId } = useAuth();
    const [protoAnchor, setProtoAnchor] = useState(null);

    const navItems = userId ? [...publicNavItems, 'Dashboard'] : publicNavItems;
    const isProtoActive = protoItems.some((p) => location.pathname === p.path);

    return (
        <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
            {navItems.map((item) => {
                const isActive = location.pathname === `/${item.toLowerCase()}`;
                return (
                    <Button
                        key={item}
                        variant="text"
                        size="small"
                        onClick={() => navigate(`/${item.toLowerCase()}`)}
                        sx={{
                            color: isActive ? J.accent : J.muted,

                            // color: isActive ? 'var(--j-accent)' : J.muted,
                            fontWeight: isActive ? 700 : 400,
                            '&:hover': { color: J.accent, bgcolor: 'transparent' },
                        }}
                    >
                        {item}
                    </Button>
                );
            })}

            {userId && import.meta.env.DEV && (
                <>
                    <Button
                        variant="text"
                        size="small"
                        onClick={(e) => setProtoAnchor(e.currentTarget)}
                        sx={{
                            color: isProtoActive ? J.accent : J.muted,
                            fontWeight: isProtoActive ? 700 : 400,
                            '&:hover': { color: J.accent, bgcolor: 'transparent' },
                        }}
                    >
                        Proto's
                    </Button>
                    <Menu
                        anchorEl={protoAnchor}
                        open={!!protoAnchor}
                        onClose={() => setProtoAnchor(null)}
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                        // zIndex above JxForm windows — JxFormBase base zIndex 1500 + PINNED_OFFSET 10000
                        sx={{ zIndex: 20000 }}
                        slotProps={{
                            paper: {
                                sx: {
                                    mt: 1,
                                    minWidth: 180,
                                    bgcolor: '#0d1f33',
                                    border: '0.5px solid #294766',
                                    borderRadius: '4px',
                                    boxShadow: '0 8px 28px rgba(0, 0, 0, 0.6)',
                                    fontFamily: "'DM Sans', sans-serif",
                                },
                            },
                        }}
                    >
                        {protoItems.map(({ label, path }) => {
                            const isProtoItemActive = location.pathname === path;
                            return (
                                <MenuItem
                                    key={path}
                                    onClick={() => {
                                        navigate(path);
                                        setProtoAnchor(null);
                                    }}
                                    sx={{
                                        fontSize: 13,
                                        fontFamily: "'DM Sans', sans-serif",
                                        color: isProtoItemActive ? J.accent : '#b0c8e0',
                                        fontWeight: isProtoItemActive ? 700 : 400,
                                        '&:hover': { bgcolor: '#05407a' },
                                    }}
                                >
                                    {label}
                                </MenuItem>
                            );
                        })}
                    </Menu>
                </>
            )}
        </Box>
    );
}
